import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=3b65bff6&scoped=true"
import script from "./Brand.vue?vue&type=script&lang=js"
export * from "./Brand.vue?vue&type=script&lang=js"
import style0 from "./Brand.vue?vue&type=style&index=0&id=3b65bff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b65bff6",
  null
  
)

export default component.exports